<template>
  <div class="row">
    <div class="col-md-12">
      <table class="table table-bordered bg-white table-sm" v-if="item">
        <tbody>
          <tr>
            <td colspan="3">
              Nome do Grupo: <b>{{ item.nome_grupo }}</b>
            </td>
          </tr>
          <tr>
            <td>
              {{ $t("Protocolo") }}: <b>{{ item.protocolo }}</b>
            </td>
            <td>
              Criado: <b>{{ item.cadastrado }}</b>
            </td>
            <td>
              Atualizado: <b>{{ item.atualizado }}</b>
            </td>
          </tr>
          <tr>
            <td>
              Técnico responsável:
              <b v-if="item.responsavel">{{ item.responsavel.name }}</b>
            </td>
            <td>
              Unidade:
              <b v-if="item.unidade">{{ item.unidade.nome }}</b>
            </td>
            <td>
              Status:
              <b v-if="item.unidade" v-html="item.status_nome"></b>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              Faixa Etária dos Usuários: <b>{{ item.faixa_etaria_nome }}</b>
            </td>
            <td>
              Inscritos: <b>{{ item.inscritos }}/{{ item.numero_vagas }}</b>

              <b-link
                href="#"
                v-if="item.inscritos >= item.numero_vagas"
                v-b-tooltip.hover
                title="Atingiu limite de inscritos!"
              >
                <b-icon
                  icon="exclamation-triangle-fill"
                  variant="warning"
                  animation="fade"
                ></b-icon>
              </b-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ["item"],
};
</script>
